import { APIBaseResponse } from "../api";

export enum AdvisorStatus {
  IN_PROGRESS = 'in_progress',
  DELETED = 'deleted',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DELETION_IN_PROGRESS = "deletion_inprogress",
  FAILED = "failed",
}
export interface GetAdvisorPrompts extends APIBaseResponse {
  data: {
    qa_prompts: string;
  };
}
export interface GetAdvisorEnquiryPrompts extends APIBaseResponse {
  data: {
    enquirybuilder_prompts: string;
  };
}
export interface GetAdvisorsAPIResponse extends APIBaseResponse {
  data: Advisor[];
}

export interface createAdvisorResponse extends APIBaseResponse {
  data: Advisor;
}
export interface UpdateAdvisorStatusResponse extends APIBaseResponse {
  data: { [key: string]: any; };
}
export interface DeleteAdvisorResponse extends APIBaseResponse {

  data: object;
}

interface AdvisorAsset {
  s3_path: string;
  asset_id: string;
  filename: string;
  asset_key: string;
}

/** Advisor metadata from API (same level as advisor_id). */
export interface AdvisorMetadata {
  palview?: 'widget' | 'dock' | string;
  [key: string]: unknown;
}

export interface Advisor {
  advisor_id: string;
  tenant_id: string;
  name: string;
  description: string;
  conversation_starters: string[];
  status: AdvisorStatus;
  character_limit: number;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
  chat_api: string | null;
  chat_title: string;
  visibility: Visibility;
  assets: AdvisorAsset[];
  is_default: string;
  workflow_data: any; // Assuming workflow_data can be of any type, you can replace it with a specific type if known
  is_stream?: boolean;
  advisor_type?: string;
  code?: string | null;
  metadata?: AdvisorMetadata | null;
}
export type Visibility = 0 | 1;

interface AdvisorAsset {
  asset_key: string;
  filename: string;
}

export interface AdvisorAssetLogoRequestPayload {
  data: AdvisorAsset[];
}
export interface GetUrlSourceListResponse extends APIBaseResponse {
  data: string[];
}

type AdvisorId = string; // Assuming advisor ID is always a string

export interface InvitePalPayload {
  email: string;
  advisor_id: AdvisorId;
}

interface InvitePalUserData {
  resource_id: string;
  user_id: string | null;
  user_email: string;
  advisor_ids: AdvisorId[];
  tenant_id: string | null;
  created_at: string; // Assuming date-time string format
  updated_at: string; // Assuming date-time string format
  created_by: string;
  updated_by: string;
}

export interface InvitePalAPIResponse extends APIBaseResponse {
  data: InvitePalUserData[];
}
export interface GetInviteUsersForAdvisorResponse extends APIBaseResponse {
  data: [{email: string, status: string}];
}